import { createContext } from 'react';
import { AuthState } from './auth.types';

export const InitialAuth: AuthState = {
  isAuthenticated: false,
  isLoading: true,
  user: undefined,
  dispatch: () => null,
  permissions: null,
  area_leader: null,
};

export const AuthContext = createContext<AuthState>(InitialAuth);
